import { FC } from 'react';
import { formLayoutPaddingTop, formLayoutStickyStyles } from './FormLayout.styles';
import Box from 'yoda-ui/Box';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const FormLayoutRightPanel: FC = ({ children }) => {
  return (
    <Box
      paddingTop={ formLayoutPaddingTop }
      display="flex"
      marginLeft={ YodaSpacing.large }
      sx={ formLayoutStickyStyles }
    >
      { children }
    </Box>
  );
};

export default FormLayoutRightPanel;
